const state = {
  shipmentNeedConfirm: 0,
}

const mutations = {
  set_shipment_need_confirm (store, data) {
    store.shipmentNeedConfirm = data
  }
}
const actions = { }
const getters = { }

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
}
